define('fukit/behavior/resource.errors.behavior',['require','exports','module','underscore','backbone','marionette','backbone.radio','datakit/util/getobject'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      Backbone  = require('backbone'),
      Mn        = require('marionette'),
      Radio     = require('backbone.radio'),
      getobject = require('datakit/util/getobject');

  // by default, resource error behavior listens to all controller resources
  // for errors and displays them in the error message view. Must added to
  // UIKit.Message
  var ResourceErrorsBehavior = Mn.Behavior.extend({
    defaults: {
      // if true, will display field validation error messages,
      // otherwise field validations will be ignored
      useFieldValidationMessages: false,

      // for legacy support, when messages are hidden or shown via radio request,
      // it will only happen when this option is true
      clearErrorMessagesOnSync: false,

      // if true, whenever new messages appear, all previous error messages
      // will be cleared
      clearPreviousErrorMessages: false,

      // by default, when resources synces, all of it's errors will be cleared.
      // add resource to this array if you want the error from it to persist
      // on sync
      persistErrorOnSyncResources: [],

      // specify controller resources to ignore errors on
      // errors from additionalResources will still show
      // // example:
      // ['@resources.training']
      // if key is misspelled, resource value will be used to match up resources to ignore
      ignoreControllerResources: [],

      // if you want to ignore errors on all controller resources instead of defining an array
      // you can set this option to true. If includeOnlyControllerResources is defined, this
      // option will be ignored
      ignoreAllControllerResources: false,

      // instead of ignoring controller resources, only listen to error on these resources +
      // additionalResources
      // example:
      // ['@resources.training']
      includeOnlyControllerResources: [],

      // if resource is not declared inside of the controller, you can
      // specify it inside of this object
      // example:
      // {
      //    training: '@resources.training'
      // }
      additionalResource: {},
    },

    initialize: function() {
      // legacy support
      var self = this;
      Radio.channel('validations.summaryView').on('setVisibility', function(visibility) {
        if (self.getOption('clearErrorMessagesOnSync')) {
          self.view.visible = visibility;
        }
      });
    },

    onFirstBeforeRender: function() {
      this.setupMesssageViewOptions();
      this.setupResourceErrorHandler();
    },

    setupResourceErrorHandler: function() {
      //prettier-ignore
      var controller                     = Radio.channel('AppKit.controllerService').request('controller'),
          controllerResources            = _.result(controller, 'resources'),
          ignoreControllerResources      = this.getOption('ignoreControllerResources'),
          ignoreAllControllerResources   = this.getOption('ignoreAllControllerResources'),
          includeOnlyControllerResources = this.getOption('includeOnlyControllerResources'),
          additionalResources            = this.getOption('additionalResources');

      if (!_.isEmpty(includeOnlyControllerResources)) {
        var errorResources = {};
        _.each(controllerResources, function(resource, key) {
          if (_.indexOf(includeOnlyControllerResources, resource) >= 0) {
            errorResources[key] = resource;
          }
        });
        this.listenToErrorOnResources(_.extend({}, errorResources, additionalResources));
      } else if (ignoreAllControllerResources) {
        this.listenToErrorOnResources(_.extend({}, additionalResources));
      } else if (!_.isEmpty(ignoreControllerResources)) {
        var errorResources = {};
        _.each(controllerResources, function(resource, key) {
          if (_.indexOf(ignoreControllerResources, resource) < 0) {
            errorResources[key] = resource;
          }
        });

        this.listenToErrorOnResources(_.extend({}, errorResources, additionalResources));
      } else {
        this.listenToErrorOnResources(_.extend({}, controllerResources, additionalResources));
      }
    },

    onResourceError: function(model, errResponse, options) {
      //prettier-ignore
      var allErrors = this.getResourceErrorArray(errResponse),
          errors = (this.getOption('useFieldValidationMessages')) ? allErrors : this.withoutFieldValidationErrors(allErrors);

      if (_.isArray(errors)) {
        if (errors.length > 0) {
          if (this.getOption('clearPreviousErrorMessages')) {
            this.view.collection.reset();
          }
          var errorModels = this.view.collection.add(errors);

          if (this.shouldClearResourceErrors(model)) {
            this.listenToOnce(model, 'sync', function(model, resp, options) {
              if (!options || !options.persistError) {
                this.view.collection.remove(errorModels);
              }
            });
          }

          // clear old error when new error occurs for the same resource
          this.listenToOnce(model, 'error', function(model, resp, options) {
            this.view.collection.remove(errorModels);
          });
        }
      }
    },

    listenToErrorOnResources: function(resources) {
      _.each(
        resources,
        function(resource) {
          this.listenTo(resource, 'error', this.onResourceError);
        },
        this
      );
    },

    shouldClearResourceErrors: function(model) {
      return _.indexOf(this.getOption('persistErrorOnSyncResources'), model) < 0;
    },

    getResourceErrorArray: function(errResponse) {
      return getobject.get(errResponse, 'xhr.responseJSON.errors') || [];
    },

    withoutFieldValidationErrors: function(errors) {
      var errors = _.reject(errors, function(error) {
        return !_.isUndefined(error.field);
      });

      return errors;
    },

    setupMesssageViewOptions: function() {
      this.view.collection = new Backbone.Collection();
      this.view.format = 'error';
      this.view.visible = false;
      this.view.dismissable = true;
      this.view.childBindings = {
        text: 'message',
      };

      this.listenTo(this.view.collection, 'update reset', function() {
        if (this.view.collection.isEmpty()) {
          this.view.visible = false;
        } else {
          this.view.visible = true;
        }
      });
    },
  });
  module.exports = ResourceErrorsBehavior;
});

